export enum FeatureToggle {
    d20260827_codearts_logo,
    d20260730_fontys_gs_richting,
    d20260827_toevoegen_isbeschikbaar_contactpersoon,
    d20261005_uitfaseren_portaal_bekijken_foto,
    d20260828_CompetentieMatrix,
    d20260227_pro6_prive_email,
    d20260617_vrij_veld_lijst_config_standaard_niet_zichtbaar,
    d20211101_VolgOnderwijsVersieMoment,
    d20261012_inzage_logging_pakketboom,
    d20260710_waardepapier_niet_regulier_examen_datum_correctie,
    d20260709_vervang_tiny_mce,
    d20250115_FB46887_NHLStendenOnderwijsSoorten,
    d20260616_excel_vaste_kolom_headers,
    d20261009_crud_account_functie_toegang,
    d20261005_deletion_context_ods,
    d20260901_FB48683_datumEindeInstroom,
    d20260728_uoc_cijferlijst,
    d20260803_gradingtable_curriculum_supplement,
    d20260715_bewaartermijn_bestandsuitwisseling,
    d20260701_joint_degree_herinschrijvingen_nawerk,
    d20260323_unified_row_selection,
    d20260408_menu_verbeteringen,
    d20260924_edux_thuis_scopes,
    d20261019_verificatie_niet_zelf_kunnen_zetten,
    d20261009_crud_studentengroepen,
    d20260310_pilot_edu_wallet_rug,
    d20260518_ooapi_eduxchange_ontsluiting,
    d20260909_UVH_serviceverzoek_waardepapieren,
    d20260410_financieel_akkoord_examen_definitief,
    d20260713_titel_niet_versieafhankelijk,
    d20260715_eduxchange_inschrijven,
    d20260523_minder_sorteerbare_kolommen,
    d20260429_studielast_per_pakket,
    d20260511_crud_webhooks,
    d20260820_sufficientie_export_import_bulk_verwijderen,
    d20260821_crud_create_and_delete,
    d20260928_opleiding_naam_datum_van,
    d20261007_AanmeldSupplementen_aan_UOC,
    d20260630_BearerToken_Security_Verbeteringen,
    d20260702_lijstweergave_opslaan,
    d20250918_nieuwe_docent_module,
    d20220301_organisatietree_naar_topbar,
    d20260512_schoolnaam_verplicht_voor_upload,
    d20250129_AVG_feedback,
    d20260513_rename_null_filters,
    d20240904_sl_referentietabellen_automatische_import,
    d20260909_Webservices_uitbreiden_met_soort_en_organisatie,
    d20260708_versiekolommen_ods,
    d20260715_telefoonnummer_recht,
    d20250220_verwijderen_centraal_geverifieerde_nationaliteit,
    d20260320_uitfaseren_factuurverzoek_labels,
    d20201116_Sta_Vastleggen_Toe,
}
